import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  vipInvitations: [],
  totalVipInvitationsItems: 0,
  totalVipInvitationsPages: 0,
  vipInvitationPackage: {},
  currentInvitedAttendees: [],
  batchedInvitationsItems: []
}

const getters = {
  getBatchedInvitationsItems: state => state.batchedInvitationsItems,
  getVipInvitations: state => state.vipInvitations,
  getTotalVipInvitationsItems: state => state.totalVipInvitationsItems,
  getTotalVipInvitationsPages: state => state.totalVipInvitationsPages,
  getVipInvitationPackage: state => state.vipInvitationPackage,
  getCurrentInvitedAttendees: state => state.currentInvitedAttendees
}

const actions = {
  async fetchVipInvitations ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const {data} = await this.$axios.get(api.attendee.getAttendeeVipInvitations(payload))
      commit(types.SET_VIP_INVITATION, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateVipInvitation ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.registrationVipInvitation.updateInvitation(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Vip invitation was updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteVipInvitation ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.registrationVipInvitation.deleteInviation(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Vip invitation was deleted!')
      commit(types.SET_VIP_INVITATION_PACKAGE)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },

  async deleteBatchedInvitation ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.registrationVipInvitation.deleteBatchedInvitation(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitation was deleted!')
      commit(types.SET_VIP_INVITATION_PACKAGE)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invitations wasn\'t deleted')
      throw err
    } finally {
      this.dispatch('fetchBatchedInvitations')
      commit(types.SET_SPINNER_STATUS, false)
    }
  },

  async fetchBatchedInvitations ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const {data} = await this.$axios.get(api.registrationVipInvitation.fetchBatchedInvitations())
      commit(types.SET_BATCHED_INVITATIONS, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invitations not loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchInvitedAttendeesByCode ({commit}, code) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const {data} = await this.$axios.get(api.registrationVipInvitation.fetchInvitedAttendeesByCode(code))
      commit(types.SET_BATCHED_INVITATION_ATTENDEES, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invited attendees not loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async saveBatchedInvitations ({commit}, items) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.registrationVipInvitation.saveBatchedInvitations(), items)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invitation not saved')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendBatchedInvitations ({commit}, data) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.registrationVipInvitation.sendBatchedInvitations(), data)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitations sent!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invitation not sent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async reSendBatchedInvitations ({commit}, data) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.registrationVipInvitation.reSendBatchedInvitations(), data)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitations resent!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Invitation not resent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVipInvitationPackage ({commit}, packageId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const {data} = await this.$axios.get(api.registrationVipInvitation.fetchInvitationPackage(packageId))
      commit(types.SET_VIP_INVITATION_PACKAGE, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitation package wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateVipInvitationPackage ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.registrationVipInvitation.updateInvitationPackage(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Vip invitation package was updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async enableVipInvitationPackage ({commit}, idPackage) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.put(api.registrationVipInvitation.enableInvitation(), idPackage)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitation package was enabled')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t enabled')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async disableVipInvitationPackage ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.registrationVipInvitation.disableInvitation(), id)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitation package was disabled')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t disabled')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resendVipInvitation ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.registrationVipInvitation.resendInvitation(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitation was successfully sent')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Vip invitations wasn\'t resent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_BATCHED_INVITATIONS] (state, data) {
    state.batchedInvitationsItems = data
  },
  [types.SET_BATCHED_INVITATION_ATTENDEES] (state, { attendees }) {
    state.currentInvitedAttendees = attendees
  },
  [types.SET_VIP_INVITATION] (state, { vipInvitations, totalPages, totalItems }) {
    state.vipInvitations = [...vipInvitations]
    state.totalVipInvitationsPages = totalPages
    state.totalVipInvitationsItems = totalItems
  },
  [types.SET_VIP_INVITATION_PACKAGE] (state, invitationPackage) {
    state.vipInvitationPackage = invitationPackage
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/registrationVipInvitation.js